import { IPhone, phoneType } from "./types-ensure";

export const initialMapPhone = (phone?: IPhone | null) => {
  return phone ? phone : phoneType();
};

export const finalMapPhone = (phone: IPhone | null) => {
  return phone && !phone.phoneNumber ? null : phone;
};
